import { StyledSkeleton } from "@components/skeleton/Skeleton.styles";
import React from "react";

/**
 * Skeleton component, used by every component that supports skeleton loading.
 * styles for the skeleton passed as a props,
 * so that Skeleton component takes care of the rendering and can be easily rewritten in case ux changes.
 * */
interface ISkeletonProps {
    width: string;
    height: string;
    borderRadius?: string;
    style?: React.CSSProperties;
    testid?: string;
}

const Skeleton: React.FunctionComponent<ISkeletonProps> = (props) => {
    const style: React.CSSProperties = {
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius,
        ...(props.style ?? {})
    };

    return (
            <StyledSkeleton style={style}
                            data-testid={props.testid}>
            {props.children}
        </StyledSkeleton>
    );
};

export default Skeleton;